<template>
  <div v-if="isLoaded" class="messages-list">
    <page-title>
      <div class="subject">{{ parent.subject }}</div>

      <div v-if="parent.booking" class="h6 booking">
        {{ booking }}
      </div>
    </page-title>

    <b-card>
      <b-card-body v-for="message in messages" :key="message.id">
        <message :value="message" :is-back-office="true">
          {{ message.content }}
        </message>
      </b-card-body>

      <b-col cols="12" class="answer-section">
        <b-row>
          <b-col cols="12" md="9" class="new-message">
            <textarea name="new_message" v-model="newMessage"
                      :placeholder="$t('message.create.placeholder')"
            />
          </b-col>

          <b-col cols="12" md="3">
            <button class="btn orange-white form-button centered-button"
                    @click="sendMessage"
            >
              {{ $t('_send') }}
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <file-input @input="setFile" placeholder=" " id="tooltip-upload" class="bg-light">
              <template slot="file-name" slot-scope="{ names }">
                <b-badge class="orange-white">{{ names[0] }}</b-badge>
              </template>
            </file-input>
          </b-col>
        </b-row>
      </b-col>

      <div class="col-lg-6 offset-lg-3">
        <b-alert v-if="error" variant="danger" show dismissible>
          {{ $t('message.alert.failure') }}
        </b-alert>
      </div>
    </b-card>
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import AbstractApi from '@/api/abstractApi'
import formatter from '@/components/global/mixins/formatterMethods'
import pageTitle from '@/components/backoffice/pageTitle'
import message from '@/components/frontoffice/discussion/message'
import fileInput from '@/components/frontoffice/form/baseInput/file'

export default {
  components: {
    pageTitle,
    message,
    fileInput
  },

  mixins: [formatter],

  data () {
    return {
      commonApi: new CommonApi(),
      isLoaded: false,
      messages: null,
      newMessage: '',
      error: false,
      fileToSend: null
    }
  },

  created () {
    let apiObject = new AbstractApi('message', this.$route.params.id)
    this.setFile(null)
    apiObject.loadEntity().then(response => {
      if (response.data.success) {
        this.messages = response.data.data
      }
    }).then(() => { this.isLoaded = true })
  },

  methods: {
    setFile (file) {
      this.fileToSend = file
    },

    sendMessage () {
      let data = new FormData()
      data.set('content', this.newMessage)
      data.set('parent', this.$route.params.id)
      data.set('file', this.fileToSend)

      this.commonApi.sendChildMessage(data)
        .then(response => {
          if (response.data.success) {
            this.messages.push(response.data.data)
            this.newMessage = ''
          } else {
            this.error = true
          }
        })
    }
  },

  computed: {
    parent () {
      return this.messages.sort((m1, m2) => {
        if (m1.id < m2.id) return -1
        else if (m1.id > m2.id) return 1
        else return 0
      })[0]
    },

    booking () {
      let transRef = this.parent.booking.ref
        ? `n° ${this.parent.booking.ref}`
        : this.$t('_unknown').toLowerCase()

      return `
        ${this.$tc('booking.default', 1)}
        ${this.parent.booking.is_online ? 'Online' : 'Offline'}
        ${transRef}
        ${this.$t('_period.from')}
        ${this.formatDate(this.parent.booking.arrival_date)}
        ${this.$t('_period.to')}
        ${this.formatDate(this.parent.booking.departure_date)}
      `
    }
  }
}
</script>
